// Here you can require the custom modules for this application like the admin one,
// for each module you need to add a folder in 'app/javascript' containing at least
// an 'index.js' file as the entrypoint.
require('admin')
